<clx-data-grid id="m2mrouter" version="1" [data]="dataSource" [showFilter]="true" [pageSize]="25" test-id="m2mrouter.grid.status"
    [showGroupPanel]="false" [showSearchPanel]="false" [remoteOperations]="true" [showHeaderFilter]="true">
    <clx-grid-column 
        dataField="iccid"
        dataType="string"
        i18n-caption="@@m2mrouter.list.iccid"
        caption="ICCID"
        width="150"
        [allowSearch]="false"
        [filterOperations]="equalFilter">
        <ng-template let-cell="item">
            <a routerLink="/Administration/M2MRouter/{{cell.data.iccid}}" title="{{cell.data.iccid}}">{{cell.data.iccid}}</a>
        </ng-template>
</clx-grid-column>
    <clx-grid-column 
        dataField="state"
        dataType="string"
        i18n-caption="@@m2mrouter.list.state"
        caption="State"
        width="150"
        [allowFiltering]="false"
        [allowHeaderFiltering]="true"
        [allowSearch]="false"
        [headerFilter]="deviceStateHeaderFilterConfig">
        <ng-template let-cell="item">
            {{cell.data.state | translateM2MDeviceState}}
        </ng-template>
    </clx-grid-column>
    <clx-grid-column 
        dataField="contractNumber"
        dataType="string"
        i18n-caption="@@m2mrouter.list.contractnumber"
        caption="Contract number"
        width="150"
        [allowFiltering]="false"
        [allowSearch]="false">
    </clx-grid-column>
    <clx-grid-column 
        dataField="additionalInformation"
        dataType="string"
        i18n-caption="@@m2mrouter.list.description"
        caption="Description"
        width="150"
        [allowFiltering]="false"
        [allowSearch]="false">
    </clx-grid-column>
    <clx-grid-column 
        dataField="assignedToPlantName"
        dataType="string"
        i18n-caption="@@m2mrouter.list.assignedtoplantname"
        caption="Plant name"
        width="150"
        [allowFiltering]="false"
        [allowSearch]="false"
        [allowSorting]="false">
    </clx-grid-column>
    <clx-grid-column 
        dataField="imsi"
        dataType="string"
        i18n-caption="@@m2mrouter.list.imsi"
        caption="IMSI"
        width="150"
        [allowSearch]="false"
        [allowSorting]="true"
        [filterOperations]="equalFilter">
    </clx-grid-column>
    <clx-grid-column 
        dataField="serviceProfile"
        dataType="string"
        i18n-caption="@@m2mrouter.list.serviceprofile"
        caption="Service Profile"
        width="150"
        [allowSearch]="false"
        [allowSorting]="true"
        [allowFiltering]="false">
    </clx-grid-column>
</clx-data-grid>